
import { defineComponent, reactive, ref } from 'vue'
import EmployeeFormFieldRoles from '@/components/employees/form-fields/roles.vue'
import EmployeeFormFieldRepeatPassword from '@/components/employees/form-fields/repeat-password.vue'
import EmployeeFormFieldPassword from '@/components/employees/form-fields/password.vue'
import EmployeeFormFieldLastName from '@/components/employees/form-fields/last-name.vue'
import EmployeeFormFieldFirstName from '@/components/employees/form-fields/first-name.vue'
import EmployeeFormFieldEmail from '@/components/employees/form-fields/email.vue'
import QForm from 'quasar/src/components/form/QForm.js';
import { CreateEmployeePayload, useEmployeeModule } from '@/modules/employees'
import { EmployeeRouteNames } from '@/router/routes-names'
import { useFormModule } from '@/modules/_shared/forms'
import { useRouter, useRoute } from 'vue-router'

type CreateEmployeeModel = Partial<CreateEmployeePayload & {repeatPassword: string}>

export default defineComponent({
    name: 'employees-create-new-form',
    components: {
        EmployeeFormFieldRoles,
        EmployeeFormFieldRepeatPassword,
        EmployeeFormFieldPassword,
        EmployeeFormFieldLastName,
        EmployeeFormFieldFirstName,
        EmployeeFormFieldEmail
    },
    setup () {
        const { createEmployee } = useEmployeeModule()
        const { submitForm, createOnSuccess } = useFormModule()
        const form = ref<QForm>()
        const router = useRouter()
        const route = useRoute()
        const employeeModel = reactive<CreateEmployeeModel>({
            email: undefined,
            firstName: undefined,
            lastName: undefined,
            password: undefined,
            repeatPassword: undefined,
            roles: []
        })

        const moveToList = () => router.push({ name: EmployeeRouteNames.LIST, query: { page: route.query.page } })

        const onSubmit = () => submitForm(
            form.value,
            async () => createEmployee(employeeModel as CreateEmployeePayload),
            createOnSuccess('New employee created')
        ).then(moveToList)

        return {
            onSubmit,
            employeeModel,
            form,
            routesNames: EmployeeRouteNames,
            route
        }
    }
})
